import React from "react";
import PropTypes from "prop-types";
import CloseIcon from "./icons/CancelIcon";
import AcceptIcon from "./icons/AcceptIcon";
import * as styles from "./BVValidationLabel.css";
import { cx } from "emotion";

export class BVValidationLabel extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { className, type, customDangerLabel } = this.props;
        return type === "danger" ? (
            <div className={cx(styles.container, className)}>
                <span className={styles.validationText}>
                    {customDangerLabel ? customDangerLabel : "Необходимо"}
                </span>
                <CloseIcon className={styles.dangerIcon} />
            </div>
        ) : (
            <AcceptIcon className={cx(styles.accept, className)} />
        );
    }
}

BVValidationLabel.propTypes = {
    type: PropTypes.string,
    className: PropTypes.string
};